import Image from "components/image.component/image.component";
import { RunningText } from "components/text.components/running.text.component/running.text.component";
import { SmallText } from "components/text.components/small.text.component/small.text.component";
import { ImageSizes } from "globals/enums/global.enum";
import React from "react";
import ListDataTable from "../list.data.table.component/list.data.table.component";
import classNames from "classnames";
import { User } from "schemas/user.schemas/user.schema";

interface UserSelectionListProps {
  users: User[];
  selectedUsers: User[];
  onClick?: (user: User) => void;
}

const UserSelectionList = ({
  users,
  selectedUsers,
  onClick,
}: UserSelectionListProps): JSX.Element => {
  return (
    <ListDataTable
      data={users}
      onClick={onClick}
      columns={[
        {
          flex: 0,
        },
        {
          flex: 0,
        },
        {
          flex: 2,
        },
      ]}
      dataTableItemBuilder={(dataItem: User, index: number) => {
        const isSelected = selectedUsers?.find((selectedItem: any) => {
          return selectedItem._id === dataItem._id;
        });

        return {
          key: dataItem._id,
          className: classNames({
            "list-data-table-body-item-selected": isSelected,
          }),
          children: [
            {
              child: <></>,
              className: "mr-10",
            },
            {
              child: (
                <Image
                  rounded={false}
                  imageUrl={dataItem?.profileImageUrl}
                  size={ImageSizes.M}
                />
              ),
            },
            {
              child: (
                <div>
                  <RunningText
                    className={isSelected ? "text-color-inverted" : ""}
                  >
                    {dataItem?.firstName} {dataItem?.lastName}
                  </RunningText>
                  <SmallText
                    className={isSelected ? "text-color-inverted" : ""}
                  >
                    {dataItem?.email}
                  </SmallText>
                </div>
              ),
            },
          ],
        };
      }}
      gap={30}
      disableHeader={true}
    />
  );
};

export default UserSelectionList;
